
import { useTradeWasteContext } from "../../../tradeWasteContext";
import { motion } from "framer-motion";

import { ErrorOption, DeepMap, FieldError } from "react-hook-form";
import { CheckboxGroup } from "components/non_residential/react_hook_forms/CheckboxGroup";
import { useEffect, useState } from "react";

interface OtherInterface {
  register: Function;
  unregister: (name: string) => void;
  setValue: Function;
  getValues: Function;
  setError: (name: string, error: ErrorOption) => void;
  clearErrors: (name?: string | string[] | undefined) => void;
  errors: DeepMap<Record<string, any>, FieldError>;
  watch: Function;
}

const Other = ({
  register,
  unregister,
  errors,
  watch
}: OtherInterface) => {
  const [isSelected, setIsSelected] = useState<boolean>(false)
  const [tradeWasteContext] = useTradeWasteContext();
  const new_application_other = watch(['other']);
  const len = new_application_other?.length ?? 0
  useEffect(() => {
    setIsSelected(len > 0)
  }, [len]);

  const variants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  }
  return (
    <motion.section
      initial="hidden"
      animate="visible"
      variants={variants}
    >
      <CheckboxGroup
        name="other"
        register={register}
        unregister={unregister}
        registerOptions={{
          required: "Please select at least one option"
        }}
        legend="Please select at least one "
        errorMessage={errors?.other?.message as string}
        checkboxes={[
          {
            value: "food_manufacturers",
            text: "Food manufacturers",

          },
          {
            value: "dump_facilities",
            text: "Dump facilities",

          },
          {
            value: "waste_treatment_facilities",
            text: "Waste treatment facilities",

          },
          {
            value: "laboratories",
            text: "Laboratories",

          },
          {
            value: "radioactive_waste",
            text: "Radioactive waste",

          },
          {
            value: "metal_finishers",
            text: "Metal finishers",

          },
          {
            value: "chemical_formulators",
            text: "Chemical formulators",

          },
        ]}
      />
      {
        isSelected && (
          <p>
            Online application is currently not available for your selection(s),
            please download and complete a blank application form along with any
            business specific supplement forms.{" "}
            <a
              href={tradeWasteContext.blankAppUrl}
              target="_blank"
            >
              Find application forms here
            </a>

          </p>
        )
      }
    </motion.section>
  );
};

export default Other;
